import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/modules/ui';

import { useIsPublicSharingActiveWithPermissions } from '../SecretDetail/hooks';
import { useSharingModal } from '../SecretDetail/SharingModalProvider';
import { ShareSecretModal } from '../ShareSecretModal';
import { SharingIndicatorIcon } from '../SharingIndicatorIcon';
import * as felaRules from './ShareSecretButton.rules';

export const ShareSecretButton = () => {
    const { open, toggle } = useSharingModal();

    const showIndicator = useIsPublicSharingActiveWithPermissions();

    const { css } = useFela();

    return (
        <>
            <div className={css(felaRules.container)}>
                <div className={css(felaRules.indicatorContainer)}>
                    <SharingIndicatorIcon visible={showIndicator} />
                </div>
                <Button type='text' size='large' onClick={toggle} data-testid='share-secret-button'>
                    <FormattedMessage id='secret.share.button' />
                </Button>
            </div>
            <ShareSecretModal open={open} onClose={toggle} />
        </>
    );
};
